module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_c('b', [_vm._v("TABLE OF CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split1#title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TITLE PAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split2#copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COPYRIGHT PAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split3#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781617752674_Split6#ch2"
    }
  }, [_vm._v("BRAUTWAY, SATURDAY, 7:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split7#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I-69, SATURDAY, 9:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split8#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MOUNT GOVERN, SATURDAY, 9:30 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split9#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POTENCY STREET, SATURDAY, 10:15 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split10#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOUTH MEAN STREET, SATURDAY, 10:45 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split11#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WONCHASUCKIT RIVER, SUNDAY, 2:30 AM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split12#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POTENCY STREET, SUNDAY, 3:00 AM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split13#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POTENCY STREET, SUNDAY, 10:00 AM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split14#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MACNAMARA PLAZA, SUNDAY, 1:15 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split15#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CRAMPTON, SUNDAY, 4:20 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split16#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DONNY DOES COLONICS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split17#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHANNEL 8, SUNDAY, 6:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split18#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EDEN STREET, SUNDAY, 9:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split19#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("YOUNG DON SNIVELER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split20#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POTENCY STREET, MONDAY, 10:45 AM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split21#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MT. MACREL, MONDAY, 12:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split22#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EUCALYPTUS STREET, MONDAY, 5:30 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split23#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EUCALYPTUS STREET, MONDAY, 6:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split24#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MASHPOTATO NATION, MONDAY, 8:30 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split25#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MASHPOTATO NATION, MONDAY, 9:15 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split26#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MASHPOTATO NATION, MONDAY, 9:30 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split27#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FANTASY AVENUE, MONDAY, 11:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split28#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MASHPOTATO NATION, TUESDAY, 8:00 AM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split29#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MACNAMARA PLAZA, TUESDAY, 11:00 AM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split30#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LAPDAN, TUESDAY, 10:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split31#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BELFRY STREET, WEDNESDAY, 5:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split32#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROFIT STREET, WEDNESDAY, 6:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split33#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POTENCY STREET, THURSDAY, 10:00 AM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split34#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MACNAMARA PLAZA, THURSDAY, 3:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split35#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ASTRAL PLANE, THURSDAY, 8:15 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split36#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ASTRAL PLANE, THURSDAY, 8:20 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split37#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POTENCY STREET, THURSDAY, 9:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split38#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POTENCY STREET, FRIDAY, 10:30 AM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split39#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EUCALYPTUS STREET, FRIDAY, 11:30 AM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split40#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROGUES ON THE RAWBUCKET, FRIDAY, 8:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split41#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POTENCY STREET, FRIDAY, 10:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split42#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ASTRAL PLANE, FRIDAY, 10:45 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split43#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POTENCY STREET, SATURDAY, 10:55 AM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split44#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WONCHASUCKIT RIVER, SATURDAY, 3:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split45#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CRAFTY BEAVER, SATURDAY, 5:15 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split46#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EDEN STREET, SATURDAY, 6:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split47#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MT. MACREL, SATURDAY, 7:00 PM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split48#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AFT TURD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-tx1",
    attrs: {
      "id": "tch45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617752674_Split49#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMESHOTS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66101b72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781617752674_Split4.vue
// module id = 69
// module chunks = 0